interface UseBrushfireDomainOptions {
	useLocalHttps?: boolean;
	subdomain?: string;
	port?: string;
}

interface CustomWindow extends Window {
	domain: any;
}

declare const window: CustomWindow;

export const useBrushfireDomain = (options: UseBrushfireDomainOptions) => {
	const { useLocalHttps = false, subdomain, port = "5000" } = options;
	if (window.domain === "") {
		return `http${useLocalHttps ? "s" : ""}://localhost:${port}${subdomain ? `/${subdomain}` : ""}`;
	} else {
		return `https://${subdomain ? `${subdomain}.` : ""}${window.domain}`;
	}
};
